import { Box } from '@mui/material';
import { HorizontalForm, CustomButton } from '../../../common/components';
import { formatDate } from '../../../utils/formatUtils';

const DebtNotificationsInfoBar = ({
  summary,
  currentCount,
  onSelectAll,
  disableSelectAll,
  isSelectingAll,
}) => {
  const totalRecords = summary?.total_records ?? currentCount;
  const dateFrom = summary?.date_range?.from;
  const dateTo = summary?.date_range?.to;

  const formatRangeDate = (date) => formatDate(date, { fallback: '-' });

  return (
    <HorizontalForm
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      sx={{ color: 'text.secondary' }}
    >
      <Box>
        Mostrando {currentCount} registros de {totalRecords}. Rango consultado:{' '}
        {formatRangeDate(dateFrom)} - {formatRangeDate(dateTo)}.
      </Box>

      <CustomButton
        variant="info"
        onClick={onSelectAll}
        disabled={disableSelectAll}
        isLoading={isSelectingAll}
      >
        Seleccionar todos
      </CustomButton>
    </HorizontalForm>
  );
};

export default DebtNotificationsInfoBar;
